<template>
  <el-card class="box-card">
    <div class="main">
      <el-form inline class="global-form">
        <el-form-item prop="materialTypeName">
          <el-input v-model="searchForm.materialTypeName" clearable placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item prop="materialTypeId">
          <el-cascader v-model="searchForm.materialTypeId" :options="materialTypeData" :props="{ checkStrictly: true, emitPath: false, children: 'childNode', label: 'materialTypeName', value: 'materialTypeId' }" placeholder="请选择物料分类" clearable></el-cascader>
        </el-form-item>
        <el-form-item prop="state">
          <el-select v-model="searchForm.state" clearable placeholder="请选择状态">
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button class="mb10" icon='el-icon-plus' type="primary" @click="$router.push('/property/materialmanage/add')" v-show="$ButtonShow('YMT_ADD_01')">新增分类</el-button>
      <el-button class="mb10" icon='el-icon-plus' type="primary" @click="showWarehouse" v-show="$ButtonShow('YWE_ADD_01')">仓库管理</el-button>

      <el-table v-loading="loading" :data="tableData" class="global-table" stripe max-height="550px">
        <el-table-column label="分类名称" show-overflow-tooltip prop="materialTypeName"></el-table-column>
        <el-table-column label="分类编码" show-overflow-tooltip prop="materialTypeCode"></el-table-column>
        <el-table-column label="上级分类" show-overflow-tooltip prop="parentMaterialTypeName"></el-table-column>
        <el-table-column label="状态" show-overflow-tooltip prop="state">
          <template v-slot="{ row }">
            <el-switch disabled v-model="row.state" active-value="1" inactive-value="2" @change="() => changeState(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150px" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="onStatus(row.materialTypeId,row.state)" v-show="$ButtonShow('YMT_EDT_02')">
                {{ row.state === '1' ? '禁用' : '启用' }}
            </el-button>
            <el-button type="text" @click="onEdit(row)" v-show="$ButtonShow('YMT_EDT_01')">编辑</el-button>
            <el-button type="text" @click="deleteRow(row.materialTypeId)" v-show="$ButtonShow('YMT_DEL_02')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <global-pagination
        @size-change="loadData"
        @current-change="loadData"
        :current-page.sync="page"
        :page-size.sync="size"
        :total="total">
      </global-pagination>

      <el-dialog title="仓库管理" :visible.sync="dialogVisible2" :close-on-click-modal="false" class="dialog-form" width="1000px">
        <el-table class="global-table" :data="warehouseData">
          <el-table-column label="所属项目" prop="">
            <template v-slot="{ row }">
              <span v-if="!row.isEdit">{{row.projectName}}</span>
              <el-select v-else v-model="row.projectId" filterable placeholder="请选择所属项目">
                <el-option :label="item.projectName" :value="item.projectId" v-for="(item, index) of projectList" :key="index"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="仓库名称" prop="">
            <template v-slot="{ row }">
              <span v-if="!row.isEdit">{{row.warehouseName}}</span>
              <el-input maxlength="20" v-else v-model="row.warehouseName" placeholder="请输入仓库名称"/>
            </template>
          </el-table-column>
          <el-table-column label="仓库负责人" prop="">
            <template v-slot="{ row }">
              <span v-if="!row.isEdit">{{row.warehouseLiable}}</span>
              <el-input maxlength="20" v-else v-model="row.warehouseLiable" placeholder="请输入仓库负责人"/>
            </template>
          </el-table-column>
          <el-table-column label="联系方式" prop="">
            <template v-slot="{ row }">
              <span v-if="!row.isEdit">{{row.warehouseMobile}}</span>
              <el-input maxlength="11" v-else v-model="row.warehouseMobile" placeholder="请输入联系方式"/>
            </template>
          </el-table-column>
          <el-table-column label="仓库地址" prop="">
            <template v-slot="{ row }">
              <span v-if="!row.isEdit">{{row.warehouseAddress}}</span>
              <el-input maxlength="20" v-else v-model="row.warehouseAddress" placeholder="请输入仓库地址"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="">
            <template v-slot="{ row, $index }">
              <el-button type="text" v-if="row.isEdit" @click="saveWarehouse(row)">保存</el-button>
              <el-button type="text" v-else @click="row.isEdit = true">编辑</el-button>
              <el-button type="text" class="del-btn" @click="delWarehouse(row.warehouseId, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="text" class="mt10" icon="el-icon-plus" @click="addWarehouse">新增仓库</el-button>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'Manage',
  components: {
  },
  data () {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {
        materialTypeName: '', // 物料名称
        materialTypeId: '', // 物料分类
        state: '' // 状态1启用2禁用
      },
      dialogVisible1: false,
      dialogVisible2: false,
      warehouseData: [],
      materialTypeData: [],
      materialTypeForm: {
        materialTypeId: '',
        materialTypeName: '',
        state: ''
      }
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    }
  },
  watch: {
  },
  created () {
    this.loadData()
    this.loadMaterialType()
  },
  methods: {
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.material.selectYhMaterialTypeByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    loadMaterialType () {
      this.$axios.get(this.$apis.material.selectYhMaterialTypeByList).then(res => {
        this.materialTypeData = res || []
      })
    },
    onSearch () {
      this.page = 1
      this.loadData()
    },
    onStatus (materialTypeId, status) {
      const text = status === '1' ? '禁用' : '启用'
      this.$confirm(`确认${text}吗？`, '提示').then(() => {
        this.$axios.post(this.$apis.material.updateYhMaterialTypeState, {
          materialTypeId
        }).then(() => {
          this.$message.success('操作成功!')
          this.loadData()
        })
      })
    },
    onEdit (row) {
      this.$router.push({
        path: '/property/materialmanage/edit',
        query: {
          materialTypeId: row.materialTypeId,
          materialTypeName: row.materialTypeName,
          materialTypeCode: row.materialTypeCode,
          parentMaterialTypeId: row.parentMaterialTypeId,
          state: row.state
        }
      })
    },
    deleteRow (materialTypeId) {
      this.$confirm('确认删除该物料分类吗？', '提示').then(() => {
        this.$axios.post(this.$apis.material.deleteDataYhMaterialType, {
          materialTypeId
        }).then(() => {
          this.$message.success('删除成功!')
          this.loadData()
        })
      })
    },
    showWarehouse () {
      this.dialogVisible2 = true
      this.loadWarehouseData()
    },
    loadWarehouseData () {
      this.$axios.get(this.$apis.material.selectYhWarehouseByList).then(res => {
        this.warehouseData = res.list.map((item) => {
          item.isEdit = false
          return item
        })
      })
    },
    addWarehouse () {
      this.warehouseData.push({
        isEdit: true,
        projectId: '', // 项目ID
        projectName: '',
        warehouseName: '', // 仓库名称
        warehouseLiable: '', // 责任人
        warehouseMobile: '', // 联系方式
        warehouseAddress: '' // 仓库地址
      })
    },
    saveWarehouse (data) {
      const item = JSON.parse(JSON.stringify(data))
      delete item.isEdit
      if (!item.projectId) {
        this.$message({ type: 'warning', message: '请选择项目' })
        return
      }
      if (!item.warehouseName) {
        this.$message({ type: 'warning', message: '请输入仓库名称' })
        return
      }
      if (item.warehouseMobile && !/^[0-9]*$/.test(item.warehouseMobile)) {
        this.$message({ type: 'warning', message: '联系方式为数字' })
        return
      }
      let url = this.$apis.material.insertYhWarehouse
      if (item.warehouseId) {
        url = this.$apis.material.updateYhWarehouse
      }
      this.$axios.post(url, item).then(() => {
        this.loadWarehouseData()
      })
    },
    delWarehouse (warehouseId, index) {
      if (warehouseId) {
        this.$axios.post(this.$apis.material.deleteYhWarehouse, {
          warehouseId
        }).then(() => {
          this.$message.success('删除成功!')
          this.loadWarehouseData()
        })
      } else {
        this.warehouseData.splice(index, 1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/color.scss';

.main {
    width: 100%;
    padding: 0px 10px;
}
.dialog-form {
  ::v-deep .el-dialog__body {
    padding: 20px 20px 20px 20px;
    .el-form-item--small.el-form-item{
      margin-bottom: 30px;
    }
  }
  ::v-deep .el-dialog__header {
    height: 51px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px  0  20px;
    .el-dialog__title {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}

.custom-tree {
  ::v-deep .el-tree-node__content{
    height: 32px;
  }
  ::v-deep .el-tree-node__content:hover{
    background-color: #E8FAF7 !important;
    color: $color-default;
    .icon {
      display: inline-block;
    }
  }
  .nodeName{
    font-size: 14px;
  }
  .icon {
    position: absolute;
    right: 0;
    display: none;
    i{
      margin-right: 10px;
    }
    .el-icon-delete{
      color: red;
    }
  }
}
</style>
